import { getClassifyURLValue } from "./classifyURL";
import { getImportsComplianceURLValue } from "./importscomplianceURL";
import { getExportComplianceURLValue } from "./exportComplianceURL";
import { getTransactionsURLValue } from "./transactionsURL";
import { getLandedCostURLValue } from "./landedCostURL";
import { getIntelApiUrl } from "./intelAPIUrl";
import { getDateRangeURLValue } from "./tcDateRangeURL";
import { getSearchEmbargoesURLValue } from "./embargoesURL";
import { getUserPlansByIdURLValue } from "./userPlansURL";
import { uploadAndValidateURLValue } from "./uploadandvalidate";
import { getUmsApiUrl, getUmsDashboardValue } from "./umsDashboardUrl";
import { getClassifierApiUrl } from "./classifierApiUrl";
import { rfiApiUrl } from "./getRfiUrl";
import { partnerMasterApiUrl } from "./partnerMasterUrl";
import { rpsApiUrl } from "./rpsApiUrl";
export const allApi = {
  autosuggestclassify: `${getClassifyURLValue()}/getHSCodeAutoSuggest`,
  questionaireFlow: `${getDateRangeURLValue()}/hsn_classifier_questionnaire`,
  eccnClassification: `${getDateRangeURLValue()}/eccnClassification`,
  autosuggestscheduleb: `${getClassifyURLValue()}/getScheduleBAutoSuggest`,
  autosuggestlandedcost: `${getLandedCostURLValue()}/suggestTaxableHscodes`,
  autosuggestimportscompliance: `${getImportsComplianceURLValue()}/suggestTaxableHscodes`,
  autoSuggestExportCompliance: `${getExportComplianceURLValue()}/suggestTaxableHscodes`,
  autoSuggestEccnClassification: `${getClassifyURLValue()}/getEccnAutoSuggest`,
  classifyresults: `${getClassifyURLValue()}/getClassifyResults`,
  rulingsdata: `${getClassifyURLValue()}/getRulingsData`,
  billofladingdata: `${getClassifyURLValue()}/getBillOfLadingData`,
  schedulebresults: `${getClassifyURLValue()}/getScheduleBClassifyResults`,
  importscomplianceresults: `${getImportsComplianceURLValue()}/getData`,
  exportComplianceResults: `${getExportComplianceURLValue()}/getData`,
  getCountries: `${getImportsComplianceURLValue()}/getCountries`,
  getExportCountries: `${getExportComplianceURLValue()}/getCountries`,
  getEccnCountries: `${getClassifyURLValue()}/getEccnCountries`,
  eccnClassificationResults: `${getClassifyURLValue()}/getEccnClassifyResults`,
  getCountriesClassify: `${getClassifyURLValue()}/getCountryImportsV2`,
  getCountriesScheduleB: `${getClassifyURLValue()}/getCountryExports`,
  getLandedCostTransactions: `${getTransactionsURLValue()}/getLandedCostTransactions`,
  getCountryOfImportLandedCost: `${getLandedCostURLValue()}/getCountryOfImport`,
  getCountryInfoLandedCost: `${getLandedCostURLValue()}/getCountryInfo`,
  calculateLandedCost: `${getLandedCostURLValue()}/calculateCost`,
  downloadNotes: `${getClassifyURLValue()}/downloadFile`,
  hscodeLibData: `${getClassifyURLValue()}/getSectionListHsClassification`,
  hscodeLibDataScheduleB: `${getClassifyURLValue()}/getSectionListScheduleB`,
  setAlert: `${getTransactionsURLValue()}/updateAlert`,
  updateAlertClassify: `${getTransactionsURLValue()}/updateAlertClassify`,
  downloadExcel: `${getImportsComplianceURLValue()}/downloadExcel`,
  downloadExportExcel: `${getExportComplianceURLValue()}/downloadExcel`,
  getUserProfile: `${getUmsApiUrl("getUserProfileComplete")}`,
  updateNotificationStatus: `${getTransactionsURLValue()}/updateNotificationStatus`,
  getDateRange: `${getDateRangeURLValue()}/getDateRange`,
  getPlansByUserId: `${getDateRangeURLValue()}/getPlansByUserId`,
  saveHscode: `${getDateRangeURLValue()}/save_hscode`,
  duties: `${getDateRangeURLValue()}/duties`,
  searchCompliance: `${getDateRangeURLValue()}/searchCompliance`,
  searchEmbargoes: `${getSearchEmbargoesURLValue()}`,
  getUserPlansById: `${getUserPlansByIdURLValue()}`,
  uploadAndValidate: `${uploadAndValidateURLValue()}/uploadAndValidate`,
  validateProgress: `${uploadAndValidateURLValue()}/progress`,
  validateAndLookUp: `${getDateRangeURLValue()}/validateAndLookUp`,
  validateDashboard: `${getDateRangeURLValue()}/bulkTransactions`,
  classifyTransaction: `${getDateRangeURLValue()}/classifyTransactions`,
  dashBoard: `${getDateRangeURLValue()}/dashBoard`,
  landedCostTemplate: `${getDateRangeURLValue()}/landedCostTemplate`,
  saveTemplate: `${getDateRangeURLValue()}/saveTemplate`,
  downloadExcelLandedCost: `${getLandedCostURLValue()}/downloadExcel`,
  downloadPDF: `${getDateRangeURLValue()}/classify/downloadPDF`,
  saveEccnHscode: `${getDateRangeURLValue()}/save_eccn_hscode`,
  deleteTemplate: `${getDateRangeURLValue()}/deleteTemplate`,
  downloadTransactions: `${getDateRangeURLValue()}/downloadTransactions`,
  getHscodeInfoV1: `${getDateRangeURLValue()}/getHscodeInfo_v1`,
  getUserComplianceHookData: `${getIntelApiUrl("get_user_compliance_hook_data")}`,
  getContentDashboard: `${getDateRangeURLValue()}/getContentDashboard`,
  getContentExcel: `${getDateRangeURLValue()}/getContentExcel`,
  extendAccount: `${getUmsDashboardValue()}trademo/auth/extendAccount`,
  getUserCreditsByPlan: `${getIntelApiUrl("getUserCreditsByPlan")}`,
  getChapterListHsClassification: `${getClassifyURLValue()}/getChapterListHsClassification`,
  getChapterListScheduleB: `${getClassifyURLValue()}/getChapterListScheduleB`,
  logout: getUmsApiUrl("logout"),
  fetchCountryContent: `${getDateRangeURLValue()}/fetchCountryContent`,
  emailData: `${getDateRangeURLValue()}/emailData`,
  uploadFile: `${getDateRangeURLValue()}/uploadFile`,
  ingestData: `${getDateRangeURLValue()}/ingestData`,
  deleteDelta: `${getDateRangeURLValue()}/deleteDelta`,
  replicateProduction: `${getDateRangeURLValue()}/replicateProduction`,
  generateFile: `${getDateRangeURLValue()}/generateFile`,
  getEmbargoesCountries: `${getDateRangeURLValue()}/getEmbargoesCountries`,
  getCountriesDoc: `${getDateRangeURLValue()}/getCountriesDoc`,
  searchDocuments: `${getDateRangeURLValue()}/searchDocuments`,
  downloadDocuments: `${getDateRangeURLValue()}/downloadDocuments`,
  getLcnCountries: `${getDateRangeURLValue()}/getLcnCountries`,
  getCategoryClassifyResults: `${getDateRangeURLValue()}/getCategoryClassifyResults`,
  getHeaderClassifyResults: `${getDateRangeURLValue()}/getHeaderClassifyResults`,
  getLcnClassifyResults: `${getDateRangeURLValue()}/getLcnClassifyResults`,
  searchEccnLicenses: `${getDateRangeURLValue()}/searchEccnLicenses`,
  getDetailedLicData: `${getDateRangeURLValue()}/getDetailedLicData`,
  downloadEccnPdf: `${getDateRangeURLValue()}/downloadEccnPdf`,
  getAllCountriesDashboard: `${getDateRangeURLValue()}/getAllCountriesDashboard`,
  createNewRequest: `${getDateRangeURLValue()}/createNewRequest`,
  getAllRequestDashboard: `${getDateRangeURLValue()}/getAllRequestDashboard`,
  getDashboardOverview: `${getDateRangeURLValue()}/getDashboardOverview`,
  getUserDetailsDashboard: `${getDateRangeURLValue()}/getUserDetailsDashboard`,
  getRequestDetailDashboard: `${getDateRangeURLValue()}/getRequestDetailDashboard`,
  updateRequestAssignedStatus: `${getDateRangeURLValue()}/updateRequestAssignedStatus`,
  getClassificationDashboardDetails: `${getDateRangeURLValue()}/getClassificationDashboardDetails`,
  updateClassificationRequest: `${getDateRangeURLValue()}/updateRequest`,
  getClassification: `${getDateRangeURLValue()}/getClassification`,
  updateClassificationDetail: `${getDateRangeURLValue()}/updateClassificationDetail`,
  getDetailsByHS: `${getDateRangeURLValue()}/getDetailsByHS`,
  getControls: `${getDateRangeURLValue()}/getControls`,
  updateUserClassificationMethod: `${getDateRangeURLValue()}/updateUserClassificationMethod`,
  getClassifiedRequestsDetails: `${getDateRangeURLValue()}/getClassifiedRequestsDetails`,
  suggestTaxableHscodes: `${getDateRangeURLValue()}/suggestTaxableHscodes`,
  getAnalyzerCountries: `${getDateRangeURLValue()}/getAnalyzerCountries`,
  getUserCreditDetails: `${getDateRangeURLValue()}/getUserCreditDetails`,
  tariffAnalyzer: `${getDateRangeURLValue()}/tariffAnalyzer`,
  aiAssistant: getClassifierApiUrl("aiAssistant"),
  compare_tariff_get_in_touch: `${getIntelApiUrl("compare_tariff_get_in_touch")}`,
  automatedInsight: `${getDateRangeURLValue()}/automatedInsight`,
  trademoInternalClassification: `${getDateRangeURLValue()}/trademoInternalClassification`,
  eccnAutomation: `${getDateRangeURLValue()}/eccnAutomation`,
  getComplianceCountries: `${getDateRangeURLValue()}/getComplianceCountries`,
  suggestionClassification: `${getDateRangeURLValue()}/suggestionClassification`,
  getskus: `${getDateRangeURLValue()}/getskus`,
  createNewRequestv1: `${getDateRangeURLValue()}/createNewRequestv1`,
  fileUpload: `${getDateRangeURLValue()}/fileupload`,
  getuploadlogs: `${getDateRangeURLValue()}/getuploadlogs`,
  getfile: `${getDateRangeURLValue()}/getfile`,
  fetchHomePage: `${getDateRangeURLValue()}/fetchpage`,
  getSkuData: `${getDateRangeURLValue()}/getskudata`,
  getSkuPartnerRelations: `${getDateRangeURLValue()}/getSkuPartnerRelations`,
  downloadSkuPartners: `${getDateRangeURLValue()}/downloadSkuPartners`,
  bulkclassify: `${getDateRangeURLValue()}/bulkclassify`,
  reclassify: `${getDateRangeURLValue()}/reclassify`,
  bulkignore: `${getDateRangeURLValue()}/bulkignore`,
  ignoreInvalidClassification: `${getDateRangeURLValue()}/ignoreInvalidClassification`,
  singleReclassify: `${getDateRangeURLValue()}/singlereclassify`,
  editSku: `${getDateRangeURLValue()}/editsku`,
  fetchLogs: `${getDateRangeURLValue()}/getlogs`,
  requestlogs: `${getDateRangeURLValue()}/requestlogs`,
  editRequest: `${getDateRangeURLValue()}/editrequest`,
  getRoleModulesAccess: getUmsApiUrl("acl/getRoleModulesAccess"),
  hsmap: `${getDateRangeURLValue()}/hsmap`,
  escalateUsers: `${getDateRangeURLValue()}/EscalateUsers`,
  escalateClassification: `${getDateRangeURLValue()}/escalate`,
  getAllEscalations: `${getDateRangeURLValue()}/getAllEscalations`,
  getDashboardCounts: `${getDateRangeURLValue()}/getDashboardCounts`,
  getEsLogs: `${getDateRangeURLValue()}/getEsLogs`,
  getEsDetails: `${getDateRangeURLValue()}/getEsDetails`,
  getCrLogs: `${getDateRangeURLValue()}/CrLogs`,
  getNotifications: `${getDateRangeURLValue()}/getNotifications`,
  markNotificationRead: `${getDateRangeURLValue()}/markNotificationRead`,
  getNotificationPollingStatus: `${getDateRangeURLValue()}/getNotificationPollingStatus`,
  downloadskus: `${getDateRangeURLValue()}/downloadskus`,
  getClassificationPollingStatus: `${getDateRangeURLValue()}/getClassificationPollingStatus`,
  addSkusToWatchlist: `${getDateRangeURLValue()}/addSkusToWatchlist`,
  getTradeLaneWatchlistSummary: `${getDateRangeURLValue()}/getTradeLaneWatchlistSummary`,
  addTradeLaneWatchlistBulk: `${getDateRangeURLValue()}/addTradeLaneWatchlistBulk`,
  getAllWatchlist: `${getDateRangeURLValue()}/getwatchlist`,
  disableWatchlist: `${getDateRangeURLValue()}/disableWatchlist`,
  getWatchlistLogs: `${getDateRangeURLValue()}/getWatchlistLogs`,
  downloadWatchlistLogsExcel: `${getDateRangeURLValue()}/downloadWatchlistLogsExcel`,
  getCountriesClassifier: `${getDateRangeURLValue()}/intel/getcountries`,
  getRfi: `${rfiApiUrl()}/rfi/getRfi`,
  getRfiMessages: `${rfiApiUrl()}/rfi`,
  getExternalRfi: `${rfiApiUrl()}/external-rfi`,
  getExternalRfiList: `${rfiApiUrl()}/external-rfi/list-view`,
  getExternalRfiProgress: `${rfiApiUrl()}/external-rfi/progress`,
  getExternalRfiFilters: `${rfiApiUrl()}/external-rfi/filters`,
  getExternalRfiCounts: `${rfiApiUrl()}/external-rfi/counts`,
  getEligibleRfiUsers: `${getDateRangeURLValue()}/getEligibleRfiUsers`,
  createExternalRfi: `${rfiApiUrl()}/external-rfi/create`,
  externalRfi: `${rfiApiUrl()}/external-rfi`,
  syncSku: `${getDateRangeURLValue()}/syncsku`,
  // Not under rfiApiUrl() like the externalRfi/* endpoints above - confirmed to live under the
  // `/trademo/tc` base instead (distinct from the unrelated SKU-level `reclassify`/`singleReclassify`
  // endpoints above, which point at a completely different flow).
  reclassifyExternalRfi: `${getDateRangeURLValue()}/external-rfi/reclassify`,
  fetchBomPage: `${getDateRangeURLValue()}/bompage`,
  bomUpload: `${getDateRangeURLValue()}/bomupload`,
  getBoms: `${getDateRangeURLValue()}/getboms`,
  downloadBoms: `${getDateRangeURLValue()}/downloadboms`,
  updateBom: `${getDateRangeURLValue()}/updateBom`,
  fetchSkuBomPage: `${getDateRangeURLValue()}/bompagesku`,
  getSkuBoms: `${getDateRangeURLValue()}/getskuboms`,
  getBomDetail: `${getDateRangeURLValue()}/getbomdetail`,
  saveBomDetail: `${getDateRangeURLValue()}/savebomdetail`,
  getAllCountry: `${getDateRangeURLValue()}/getAllCountry`,
  getCurrencySymbols: `${getDateRangeURLValue()}/getCurrencySymbols`,
  validateBom: `${getDateRangeURLValue()}/validatebom`,
  pollBom: `${getDateRangeURLValue()}/pollbom`,
  getTags: `${getDateRangeURLValue()}/gettags`,
  hsAutoComplete: `${getDateRangeURLValue()}/hsAutoComplete`,
  createCooRequest: `${getDateRangeURLValue()}/createCooRequest`,
  bomodel: `${getDateRangeURLValue()}/bomodel`,
  rfiStatus: `${getDateRangeURLValue()}/rfiStatus`,
  getSkuFtaData: `${getDateRangeURLValue()}/getSkuFtaData`,
  downloadSkuFtaData: `${getDateRangeURLValue()}/downloadSkuFtaData`,
  downloadModelReport: `${getDateRangeURLValue()}/downloadModelReport`,
  getFtaInitData: `${getDateRangeURLValue()}/getFtaInitData`,
  createFtaRequest: `${getDateRangeURLValue()}/createFtaRequest`,
  ftaModel: `${getDateRangeURLValue()}/ftamodel`,
  getPartnerRelations: `${getDateRangeURLValue()}/getPartnerRelations`,
  getSkusForBulkMapping: `${getDateRangeURLValue()}/getSkusForBulkMapping`,
  addPartnerRelation: `${getDateRangeURLValue()}/addPartnerRelation`,
  editPartnerRelations: `${getDateRangeURLValue()}/editPartnerRelations`,
  removePartnerRelations: `${getDateRangeURLValue()}/removePartnerRelations`,
  bulkMapPartnerRelations: `${getDateRangeURLValue()}/bulkMapPartnerRelations`,
  getTradeLanes: `${getDateRangeURLValue()}/getTradeLanes`,
  getTradeLaneFilterOptions: `${getDateRangeURLValue()}/getTradeLaneFilterOptions`,
  getTradeLaneAuditLogs: `${getDateRangeURLValue()}/getTradeLaneAuditLogs`,
  downloadTradeLanes: `${getDateRangeURLValue()}/downloadTradeLanes`,
  deleteTradeLanes: `${getDateRangeURLValue()}/deleteTradeLanes`,
  createTradeLanes: `${getDateRangeURLValue()}/createTradeLanes`,
  uploadTradeLanes: `${getDateRangeURLValue()}/uploadTradeLanes`,
  getSkuTradeLanes: `${getDateRangeURLValue()}/getSkuTradeLanes`,
  getTradeLaneLinkedSkus: `${getDateRangeURLValue()}/getTradeLaneLinkedSkus`,
  getSkusForTradeLaneLinking: `${getDateRangeURLValue()}/getSkusForTradeLaneLinking`,
  linkTradeLanesToSku: `${getDateRangeURLValue()}/linkTradeLanesToSku`,
  unlinkSkuFromTradeLane: `${getDateRangeURLValue()}/unlinkSkuFromTradeLane`,
  getTradeLanesForBulkConfigure: `${getDateRangeURLValue()}/getTradeLanesForBulkConfigure`,
  bulkConfigureTradeLanesForSkus: `${getDateRangeURLValue()}/bulkConfigureTradeLanesForSkus`,
  licenseUploadUrls: `${getDateRangeURLValue()}/license/uploadUrls`,
  licenseManual: `${getDateRangeURLValue()}/license/manual`,
  licenseDeleteUploads: `${getDateRangeURLValue()}/license/deleteUploads`,
  licenceDeterminationMeta: `${getDateRangeURLValue()}/license_determination/meta`,
  licenceDeterminationControlEntries: `${getDateRangeURLValue()}/license_determination/control_entries`,
  licenceDetermination: `${getDateRangeURLValue()}/license_determination/determine`,
  licenceDeterminationStream: `${getDateRangeURLValue()}/license_determination/determine/stream`,
  screeningConfig: `${partnerMasterApiUrl()}/partner-master/screening-config`,
  fetchPartnerPage: `${partnerMasterApiUrl()}/partner-master/homepage`,
  partnerUpload: `${partnerMasterApiUrl()}/partner-master/upload`,
  partnerData: `${partnerMasterApiUrl()}/partner-master/partnerData`,
  downloadPartners: `${partnerMasterApiUrl()}/partner-master/partnerData/download`,
  partnerHeader: `${partnerMasterApiUrl()}/partner-master/partnerHeader`,
  partnerDetails: `${partnerMasterApiUrl()}/partner-master/partnerDetails`,
  partnerScreeningDetails: `${partnerMasterApiUrl()}/partner-master/partners`,
  getPartnerLogs: `${partnerMasterApiUrl()}/partner-master/partnerDetails/audit-logs`,
  getPartnerSkuLogs: `${getDateRangeURLValue()}/auditLog`,
  viewScreeningTransactionDetails: `${rpsApiUrl()}/rps/internal/viewTransactionDetails`,
  getScreeningEntityDetails: `${rpsApiUrl()}/rps/internal/getDetails`,
  downloadScreeningReport: `${rpsApiUrl()}/rps/downloadPdf`,
  createScreeningReport: `${rpsApiUrl()}/rps/createCombinedTransactionPdf`,
};
